import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CapabilityDTO {
  id: number;
  code: string;
  category: string;
  description: string;
}

export interface UserAccessDTO {
  userId: number;
  marinaId: number;
  profile: 'ADMIN' | 'VIEWER' | 'CUSTOM';
  capabilityCodes: string[];
}

/**
 * EAS-198 — controle de acesso por capacidade (api-security).
 */
@Injectable({ providedIn: 'root' })
export class AccessControlService {

  private readonly base = environment.apiHost + '/api-security/secure/access';

  constructor(private http: HttpClient) {}

  getCatalog(): Observable<CapabilityDTO[]> {
    return this.http.get<CapabilityDTO[]>(`${this.base}/catalog`);
  }

  getUserAccess(userId: number, marinaId: number): Observable<UserAccessDTO> {
    return this.http.get<UserAccessDTO>(`${this.base}/user/${userId}/marina/${marinaId}`);
  }

  setUserAccess(userId: number, marinaId: number, body: { profile: string; capabilityCodes: string[] }): Observable<UserAccessDTO> {
    return this.http.put<UserAccessDTO>(`${this.base}/user/${userId}/marina/${marinaId}`, body);
  }
}
